export const GET_RELOCATION_DETAILS = 'GET_RELOCATION_DETAILS';

export function getRelocationDetails(relList) {
    return {
        type: GET_RELOCATION_DETAILS,
        data: relList
    }
}